var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',_vm._g(_vm._b({staticClass:"u-el-tooltip",attrs:{"content":_vm.content,"placement":_vm.placement}},'el-tooltip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_c('i',{staticClass:"el-icon-question"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }